import classNames from 'classnames';
import { Flex, Heading } from 'yoso';
import { useScoreUpCriteria } from '~/components/Challenge/Score/ChallengeScore.hooks';
import { T } from '~/components/I18n';
import gem from '~/components/Icon/gem.png';
import { format } from '~/components/Util/number';
import styles from './ChallengeScoreUpFormHero.module.scss';

export type ChallengeScoreUpFormHeroProps = {
  className?: string;
};

export const ChallengeScoreUpFormHero = ({ className }: ChallengeScoreUpFormHeroProps) => {
  const {
    data: { joinForAssetAmount, baseScore, assetType },
  } = useScoreUpCriteria();

  return (
    <Flex container alignItems="center" className={classNames(styles.root, className)}>
      <div className={styles.aside}>
        <img src={gem} className={styles.image} width={54} height={54} alt="point" />
      </div>
      <Flex flex={1} className={styles.body}>
        <Heading level={5} className={styles.title}>
          <small>
            <T name="citizen_challenge_scoreup_popup_count" options={[format(baseScore)]} />
          </small>
          {format(joinForAssetAmount)}
          {assetType}
        </Heading>
        <p className={styles.description}>
          <T name="citizen_challenge_scoreup_popup_desc2" />
        </p>
      </Flex>
    </Flex>
  );
};
